var dcUiDropDown = {
    init: function() {
        $(document).on('click', '.dc-ui.dropdown-toggle', function(e) {
            e.preventDefault();
            $(this).toggleClass('show');
            $('.dc-ui.dropdown-menu').toggleClass('show');
        });

        $(document).on('click', '.dc-ui.dropdown-item', function() {
            $('.dc-ui.dropdown-toggle').html($(this).text());
            dcUiDropDown.close();
        });

        $(document).on('click', function(e) {
            if (!$(e.target).closest('.dc-ui.dropdown').length) {
                dcUiDropDown.close();
            }
        });
    },
    close: function() {
        $('.dc-ui.dropdown-toggle').removeClass('show');
        $('.dc-ui.dropdown-menu').removeClass('show');
    }
};
